import React, { Component } from "react";
import CircularProgress from "@material-ui/core/CircularProgress";
import * as loaderReducer from "@common/store/loader/loader.reducer";
import { connect } from "react-redux";
import { getContext } from "@common/store/context";

class LoaderContainer extends Component {
  componentDidUpdate() {
    if (this.props.loading) document.body.classList.add("no-scroll");
    else document.body.classList.remove("no-scroll");
  }

  render() {
    if (this.props.loading)
      return (
        <div tabIndex="-1" className="loading-screen-blocker">
          <div
            className="loadingContent"
            style={{ backgroundColor: "transparent", top: "30%" }}
          >
            <CircularProgress style={{ height: "115px", width: "115px" }} />
          </div>
        </div>
      );
    else return null;
  }
}

function mapStateToProps(state) {
  return {
    loading: loaderReducer.isLoading(state)
  };
}

export default connect(
  mapStateToProps,
  null,
  null,
  getContext()
)(LoaderContainer);
